import { TextField } from '@material-ui/core';
import _ from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchPageStyles } from '../../global/constants/theme/styles/pages/search/search-page-layout';
import { Filter, SearchAppState, SearchState } from '../search-model';
import { completeUpdate, updateFilter } from '../search-slice';


interface SearchBarProps {
    name: string;
    label: string;
    filterProps: string[];
}

export const SearchBar = (props: SearchBarProps) => {

    const state = useSelector<SearchAppState, SearchState>(a => a.searchState);
	const hasFilters = state && state.filters && state.filters[props.name]?.filterOptions[0].filterValue;
    
    const classes = searchPageStyles();
    const [value, setValue] = useState(hasFilters ? state.filters[props.name]?.filterOptions[0].filterValue : '');
    const dispatch = useDispatch();
    const debounceSearch = _.debounce((e) => {
        const newFilter: Filter = {
            filterKey: props.name,
            filterOptions: props.filterProps?.map(a => {
                return {
                    filterKey: a,
                    filterValue: e.target.value,
                };
            }),
            partialMatch: true,
        };
        dispatch(updateFilter(newFilter));
        dispatch(completeUpdate());
    }, 500);
    const onChange = (event) => {
        setValue(event.target.value);
        debounceSearch(event);
    };

    return (
        <div className={classes.searchBar}>
            <TextField  id={props.name} label={props.label} value={value} onChange={onChange} />
        </div>
    );

};

